import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-90 pr-15" }
const _hoisted_3 = { class: "flex-1 text-13 pr-10" }
const _hoisted_4 = ["disabled", "onClick"]

import { useUpSellItems } from '@/b2c/basket/useUpSellItems';
import { computed, ComputedRef, Ref, ref } from 'vue';
import { UpSellProduct } from '@/b2c/shared/api/server-apis';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import useBasket from '@/b2c/basket/useBasket';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemUpSell',
  props: {
    itemId: null
  },
  setup(__props: any) {

const props = __props as {
    itemId: number;
}



const labels = useBlockLabels();
const { getProductsByItemId } = useUpSellItems();
const { addUpSellItem } = useBasket();

const products: ComputedRef<UpSellProduct[]> = computed(() => getProductsByItemId(props.itemId));
const pending: Ref<boolean> = ref(false);
const addToBasket = async(product: UpSellProduct): Promise<void> => {
    try {
        pending.value = true;
        await addUpSellItem({ sku: product.sku, quantity: product.quantityMultiplier, relatedItemId: props.itemId });
    } finally {
        pending.value = false;
    }
};


return (_ctx: any,_cache: any) => {
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createBlock(_Transition, { name: "o-anim-fade-300" }, {
    default: _withCtx(() => [
      (_unref(products).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product) => {
              return (_openBlock(), _createElementBlock("div", {
                key: product.sku,
                class: "bg-wild-sand px-18 py-14 mt-20 flex flex-nowrap justify-between w-full items-center"
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_ProductImage, {
                    sku: product.sku,
                    alt: product.name,
                    "aspect-ratio": 4/3,
                    "width-on-screen": 1,
                    class: "w-full"
                  }, null, 8, ["sku", "alt"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("strong", null, _toDisplayString(product.description ? product.name : _unref(labels).lineItemUpSellItemRecommendTitle), 1),
                  _createElementVNode("div", null, _toDisplayString(product.description || product.name), 1),
                  _createElementVNode("div", null, _toDisplayString(product.price.salesPrice.amount), 1)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "c-button c-button--basket",
                    disabled: pending.value,
                    onClick: _withModifiers(($event: any) => (addToBasket(product)), ["prevent"])
                  }, _toDisplayString(_unref(labels).lineItemUpSellItemAddToBasketButton), 9, _hoisted_4)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})